import React from 'react';
import Block from '../Block';
import { WrapItem, DetailsItem, DatesItem, TitleItem } from './styles';

const Item = (props: any) => {
  const { dates, details, target, id, idSelected } = props;
  return (
    <WrapItem id={`id-${id}`} isItemSelected={idSelected === id}>
      <DatesItem>{dates}</DatesItem>
      <TitleItem>{details}</TitleItem>
      <DetailsItem>
        {target !== null && target !== '' ? (
          <>
            {'Detalle:  '}
            <a href={target} target="_blank" rel="noreferrer">
              {target}
            </a>
          </>
        ) : (
          <Block />
        )}
      </DetailsItem>
    </WrapItem>
  );
};

export { Item };
